import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, Flex, Input, Item, ItemContent, ItemSide, ItemTitle, Separator, SkeletonBlock, TextBody } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Button } from "../../../../../components/Button";
export function TransferFlowFormSkeleton(t0) {
  const $ = _c(30);
  const {
    count
  } = t0;
  const t = useTranslations("wallet.TransferFlowForm");
  let t1;
  if ($[0] !== count || $[1] !== t) {
    t1 = t("title", {
      count
    });
    $[0] = count;
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t1) {
    t2 = <BottomSheetHeader className="justify-between"><BottomSheetHeaderTitle>{t1}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t("sendToLabel");
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t3) {
    t4 = <TextBody weight="semibold">{t3}</TextBody>;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t("recipientAddressPlaceholder");
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t5) {
    t6 = <Input disabled={true} placeholder={t5} />;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== t4 || $[14] !== t6) {
    t7 = <div className="grid grid-cols-2 items-center py-3.5">{t4}{t6}</div>;
    $[13] = t4;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Separator className="my-0.5" />;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== count) {
    t9 = new Array(count).fill(0).map(_temp);
    $[17] = count;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t7 || $[20] !== t9) {
    t10 = <BottomSheetBody>{t7}{t8}{t9}</BottomSheetBody>;
    $[19] = t7;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  let t11;
  if ($[22] !== t) {
    t11 = t("reviewButton");
    $[22] = t;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  let t12;
  if ($[24] !== t11) {
    t12 = <BottomSheetFooter><Flex className="justify-end"><Button disabled={true}>{t11}</Button></Flex></BottomSheetFooter>;
    $[24] = t11;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  let t13;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t2) {
    t13 = <>{t2}{t10}{t12}</>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t2;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
function _temp(_, i) {
  return <Item className="py-4" key={i} variant="unstyled"><SkeletonBlock className="order-1 size-10 shrink-0" /><ItemContent><ItemTitle><SkeletonBlock className="h-4 w-24" /></ItemTitle></ItemContent><ItemSide><SkeletonBlock className="size-6 rounded" /></ItemSide></Item>;
}